import { Button } from "../../../../components/Button";
import type { ItineraryRequest } from "../../../../types/itinerary";
import { formatRequestDateRange } from "./eventDateRange";
import "./Itinerary.css";

interface ItineraryRequestConfirmationProps {
  /** The request AS THE SERVER RECORDED IT — never the values the coach typed. */
  request: ItineraryRequest;
  /** Label for the acknowledge button. */
  doneLabel?: string;
  onDone: () => void;
}

/**
 * "We've got it" confirmation for a submitted itinerary request.
 *
 * It reads the name and dates back off the SERVER's response rather than the form state, which is
 * the whole point when the request was raised from an event already on the calendar: the coach
 * never typed them, the server derived them from the event, and this is where they get to check
 * that RosterPilot heard the right tournament.
 */
export const ItineraryRequestConfirmation = ({
  request,
  doneLabel = "Done",
  onDone,
}: ItineraryRequestConfirmationProps) => (
  <div className="itin-confirm" role="status" data-testid="itinerary-request-confirmation">
    <div className="itin-confirm__title">Request sent</div>
    <p className="itin-confirm__msg">
      We'll build the itinerary for{" "}
      <strong data-testid="itinerary-request-confirmed-name">{request.tournamentName}</strong>,{" "}
      <span data-testid="itinerary-request-confirmed-dates">
        {formatRequestDateRange(request.startDateUtc, request.endDateUtc)}
      </span>
      , and share it with your program when it's ready.
    </p>
    {request.scheduleUrl && (
      <p className="itin-confirm__msg">
        We'll start from the schedule link you sent.
      </p>
    )}
    <Button
      type="button"
      variant="primary"
      onClick={onDone}
      data-testid="itinerary-request-done"
    >
      {doneLabel}
    </Button>
  </div>
);
